import * as Mod1 from "./discourse/admin-discourse-gamification-plugin-route-map";
import * as Mod2 from "./discourse/components/gamification-leaderboard-row";
import * as Mod3 from "./discourse/components/gamification-leaderboard";
import * as Mod4 from "./discourse/components/gamification-score";
import * as Mod5 from "./discourse/components/minimal-gamification-leaderboard-row";
import * as Mod6 from "./discourse/components/minimal-gamification-leaderboard";
import * as Mod7 from "./discourse/components/modal/leaderboard-info";
import * as Mod8 from "./discourse/components/modal/recalculate-scores-form";
import * as Mod9 from "./discourse/components/period-input";
import * as Mod10 from "./discourse/connectors/user-card-metadata/gamification-score.gjs";
import * as Mod11 from "./discourse/connectors/user-profile-secondary/gamification-score.gjs";
import * as Mod12 from "./discourse/gamification-route-map";
import * as Mod13 from "./discourse/helpers/fullnumber";
import * as Mod14 from "./discourse/helpers/sum";
import * as Mod15 from "./discourse/models/gamification-leaderboard";
import * as Mod16 from "./discourse/routes/gamification-leaderboard";
import * as Mod17 from "./discourse/routes/gamification-leaderboard/by-name";
import * as Mod18 from "./discourse/routes/gamification-leaderboard/index";
import * as Mod19 from "./discourse/templates/gamification-leaderboard";
import * as Mod20 from "./discourse/templates/gamification-leaderboard/by-name";
import * as Mod21 from "./discourse/templates/gamification-leaderboard/index";
import * as Mod22 from "./initializers/admin-plugin-configuration-nav";
const compatModules = {
  "discourse/admin-discourse-gamification-plugin-route-map": Mod1,
  "discourse/components/gamification-leaderboard-row": Mod2,
  "discourse/components/gamification-leaderboard": Mod3,
  "discourse/components/gamification-score": Mod4,
  "discourse/components/minimal-gamification-leaderboard-row": Mod5,
  "discourse/components/minimal-gamification-leaderboard": Mod6,
  "discourse/components/modal/leaderboard-info": Mod7,
  "discourse/components/modal/recalculate-scores-form": Mod8,
  "discourse/components/period-input": Mod9,
  "discourse/connectors/user-card-metadata/gamification-score": Mod10,
  "discourse/connectors/user-profile-secondary/gamification-score": Mod11,
  "discourse/gamification-route-map": Mod12,
  "discourse/helpers/fullnumber": Mod13,
  "discourse/helpers/sum": Mod14,
  "discourse/models/gamification-leaderboard": Mod15,
  "discourse/routes/gamification-leaderboard": Mod16,
  "discourse/routes/gamification-leaderboard/by-name": Mod17,
  "discourse/routes/gamification-leaderboard/index": Mod18,
  "discourse/templates/gamification-leaderboard": Mod19,
  "discourse/templates/gamification-leaderboard/by-name": Mod20,
  "discourse/templates/gamification-leaderboard/index": Mod21,
  "initializers/admin-plugin-configuration-nav": Mod22,
};
export { compatModules };
export default compatModules;
